import { useInfiniteQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useWasteLogsSearch(establishmentId, searchText, enabled = true) {
  const queryReturnValues = useInfiniteQuery(
    ["waste-logs-search", { establishmentId, searchText }],
    ({ pageParam = 1 }) =>
      inventoryClient.searchWasteLogsInfiniteScroll(establishmentId, searchText, pageParam),
    {
      enabled: Boolean(enabled && searchText && searchText.length >= 2),
      staleTime: 1000 * 60 * 5,
      keepPreviousData: true,
      getNextPageParam: (lastPage, allPages) => {
        const currentPage = allPages.length;
        return currentPage < lastPage.totalPages ? currentPage + 1 : undefined;
      },
    }
  );

  return queryReturnValues;
}

export default useWasteLogsSearch;
